export interface ClassicVerseRef {
  seqid: number;
  Book: string;
  Chapter: string;
  Verse: string;
}

// 1000+ classic Bible verse references (KJV-based).
// Book field is the English book_id from book_name.csv (e.g. "Genesis", "Revelation of John").
// Text is fetched at runtime from the appropriate Bible version.
// Generated from 1000.md

export const CLASSIC_VERSES: ClassicVerseRef[] = [
  { seqid: 1, Book: "I Timothy", Chapter: "2", Verse: "4" },
  { seqid: 2, Book: "John", Chapter: "17", Verse: "17" },
  { seqid: 3, Book: "John", Chapter: "8", Verse: "32" },
  { seqid: 4, Book: "Ephesians", Chapter: "1", Verse: "13" },
  { seqid: 5, Book: "Colossians", Chapter: "1", Verse: "5" },
  { seqid: 6, Book: "II Thessalonians", Chapter: "2", Verse: "13" },
  { seqid: 7, Book: "James", Chapter: "1", Verse: "18" },
  { seqid: 8, Book: "II Timothy", Chapter: "2", Verse: "15" },
  { seqid: 9, Book: "II Thessalonians", Chapter: "2", Verse: "10" },
  { seqid: 10, Book: "Proverbs", Chapter: "3", Verse: "23" },
  { seqid: 11, Book: "I Peter", Chapter: "1", Verse: "22" },
  { seqid: 12, Book: "III John", Chapter: "0", Verse: "4" },
  { seqid: 13, Book: "II Timothy", Chapter: "3", Verse: "17" },
  { seqid: 14, Book: "I John", Chapter: "1", Verse: "6" },
  { seqid: 15, Book: "II Peter", Chapter: "1", Verse: "12" },
  { seqid: 16, Book: "I Timothy", Chapter: "3", Verse: "15" },
  { seqid: 17, Book: "II Timothy", Chapter: "3", Verse: "16" },
  { seqid: 18, Book: "II Peter", Chapter: "1", Verse: "21" },
  { seqid: 19, Book: "Matthew", Chapter: "4", Verse: "4" },
  { seqid: 20, Book: "Psalms", Chapter: "9", Verse: "105" },
  { seqid: 21, Book: "Ephesians", Chapter: "3", Verse: "3" },
  { seqid: 22, Book: "Ephesians", Chapter: "3", Verse: "5" },
  { seqid: 23, Book: "Hebrews", Chapter: "1", Verse: "1" },
  { seqid: 24, Book: "Hebrews", Chapter: "1", Verse: "2" },
  { seqid: 25, Book: "Psalms", Chapter: "9", Verse: "140" },
  { seqid: 26, Book: "I Peter", Chapter: "1", Verse: "24" },
  { seqid: 27, Book: "I Peter", Chapter: "1", Verse: "25" },
  { seqid: 28, Book: "Matthew", Chapter: "4", Verse: "35" },
  { seqid: 29, Book: "Matthew", Chapter: "5", Verse: "18" },
  { seqid: 30, Book: "Isaiah", Chapter: "40", Verse: "22" },
  { seqid: 31, Book: "Luke", Chapter: "4", Verse: "27" },
  { seqid: 32, Book: "Luke", Chapter: "4", Verse: "44" },
  { seqid: 33, Book: "Romans", Chapter: "10", Verse: "8" },
  { seqid: 34, Book: "Romans", Chapter: "10", Verse: "17" },
  { seqid: 35, Book: "I Peter", Chapter: "1", Verse: "23" },
  { seqid: 36, Book: "John", Chapter: "6", Verse: "68" },
  { seqid: 37, Book: "John", Chapter: "6", Verse: "63" },
  { seqid: 38, Book: "Hebrews", Chapter: "4", Verse: "12" },
  { seqid: 39, Book: "James", Chapter: "1", Verse: "21" },
  { seqid: 40, Book: "Psalms", Chapter: "9", Verse: "103" },
  { seqid: 41, Book: "I Peter", Chapter: "2", Verse: "2" },
  { seqid: 42, Book: "Acts", Chapter: "20", Verse: "32" },
  { seqid: 43, Book: "Ephesians", Chapter: "5", Verse: "26" },
  { seqid: 44, Book: "John", Chapter: "1", Verse: "1" },
  { seqid: 45, Book: "John", Chapter: "1", Verse: "14" },
  { seqid: 46, Book: "Isaiah", Chapter: "5", Verse: "11" },
  { seqid: 47, Book: "Isaiah", Chapter: "11", Verse: "9" },
  { seqid: 48, Book: "I Corinthians", Chapter: "8", Verse: "4" },
  { seqid: 49, Book: "Deuteronomy", Chapter: "6", Verse: "4" },
  { seqid: 50, Book: "Isaiah", Chapter: "5", Verse: "5" },
  { seqid: 51, Book: "Exodus", Chapter: "3", Verse: "14" },
  { seqid: 52, Book: "Exodus", Chapter: "3", Verse: "16" },
  { seqid: 53, Book: "Revelation of John", Chapter: "1", Verse: "8" },
  { seqid: 54, Book: "John", Chapter: "17", Verse: "3" },
  { seqid: 55, Book: "I Thessalonians", Chapter: "1", Verse: "9" },
  { seqid: 56, Book: "I Timothy", Chapter: "6", Verse: "16" },
  { seqid: 57, Book: "I Timothy", Chapter: "1", Verse: "17" },
  { seqid: 58, Book: "Psalms", Chapter: "90", Verse: "2" },
  { seqid: 59, Book: "Genesis", Chapter: "1", Verse: "1" },
  { seqid: 60, Book: "Revelation of John", Chapter: "4", Verse: "11" },
  { seqid: 61, Book: "Psalms", Chapter: "3", Verse: "9" },
  { seqid: 62, Book: "Romans", Chapter: "4", Verse: "17" },
  { seqid: 63, Book: "Romans", Chapter: "1", Verse: "20" },
  { seqid: 64, Book: "John", Chapter: "4", Verse: "24" },
  { seqid: 65, Book: "I John", Chapter: "4", Verse: "16" },
  { seqid: 66, Book: "I John", Chapter: "1", Verse: "5" },
  { seqid: 67, Book: "Ephesians", Chapter: "4", Verse: "18" },
  { seqid: 68, Book: "John", Chapter: "17", Verse: "22" },
  { seqid: 69, Book: "I Peter", Chapter: "1", Verse: "16" },
  { seqid: 70, Book: "II Timothy", Chapter: "4", Verse: "8" },
  { seqid: 71, Book: "Psalms", Chapter: "9", Verse: "14" },
  { seqid: 72, Book: "I Corinthians", Chapter: "1", Verse: "9" },
  { seqid: 73, Book: "Isaiah", Chapter: "6", Verse: "8" },
  { seqid: 74, Book: "Matthew", Chapter: "8", Verse: "19" },
  { seqid: 75, Book: "I Corinthians", Chapter: "8", Verse: "6" },
  { seqid: 76, Book: "Hebrews", Chapter: "1", Verse: "8" },
  { seqid: 77, Book: "Acts", Chapter: "5", Verse: "3" },
  { seqid: 78, Book: "Acts", Chapter: "5", Verse: "4" },
  { seqid: 79, Book: "Isaiah", Chapter: "9", Verse: "6" },
  { seqid: 80, Book: "Hebrews", Chapter: "7", Verse: "3" },
  { seqid: 81, Book: "Micah", Chapter: "5", Verse: "2" },
  { seqid: 82, Book: "Hebrews", Chapter: "9", Verse: "14" },
  { seqid: 83, Book: "Matthew", Chapter: "3", Verse: "16" },
  { seqid: 84, Book: "Matthew", Chapter: "3", Verse: "17" },
  { seqid: 85, Book: "John", Chapter: "14", Verse: "11" },
  { seqid: 86, Book: "John", Chapter: "14", Verse: "10" },
  { seqid: 87, Book: "John", Chapter: "10", Verse: "30" },
  { seqid: 88, Book: "John", Chapter: "8", Verse: "29" },
  { seqid: 89, Book: "John", Chapter: "14", Verse: "26" },
  { seqid: 90, Book: "John", Chapter: "15", Verse: "25" },
  { seqid: 91, Book: "John", Chapter: "16", Verse: "15" },
  { seqid: 92, Book: "Ephesians", Chapter: "2", Verse: "18" },
  { seqid: 93, Book: "II Corinthians", Chapter: "13", Verse: "14" },
  { seqid: 94, Book: "Numbers", Chapter: "6", Verse: "24" },
  { seqid: 95, Book: "Numbers", Chapter: "6", Verse: "25" },
  { seqid: 96, Book: "Numbers", Chapter: "6", Verse: "26" },
  { seqid: 97, Book: "Ephesians", Chapter: "1", Verse: "9" },
  { seqid: 98, Book: "Ephesians", Chapter: "1", Verse: "1" },
  { seqid: 99, Book: "Ephesians", Chapter: "3", Verse: "11" },
  { seqid: 100, Book: "Ephesians", Chapter: "1", Verse: "10" },
  { seqid: 101, Book: "Ephesians", Chapter: "3", Verse: "9" },
  { seqid: 102, Book: "I Timothy", Chapter: "1", Verse: "4" },
  { seqid: 103, Book: "I John", Chapter: "3", Verse: "2" },
  { seqid: 104, Book: "Genesis", Chapter: "1", Verse: "26" },
  { seqid: 105, Book: "Genesis", Chapter: "2", Verse: "9" },
  { seqid: 106, Book: "John", Chapter: "4", Verse: "14" },
  { seqid: 107, Book: "Romans", Chapter: "8", Verse: "10" },
  { seqid: 108, Book: "Romans", Chapter: "8", Verse: "6" },
  { seqid: 109, Book: "Romans", Chapter: "8", Verse: "11" },
  { seqid: 110, Book: "I Corinthians", Chapter: "6", Verse: "17" },
  { seqid: 111, Book: "I John", Chapter: "4", Verse: "13" },
  { seqid: 112, Book: "Ephesians", Chapter: "3", Verse: "17" },
  { seqid: 113, Book: "Ephesians", Chapter: "3", Verse: "18" },
  { seqid: 114, Book: "Ephesians", Chapter: "3", Verse: "19" },
  { seqid: 115, Book: "Colossians", Chapter: "2", Verse: "10" },
  { seqid: 116, Book: "Ephesians", Chapter: "3", Verse: "2" },
  { seqid: 117, Book: "Ephesians", Chapter: "3", Verse: "7" },
  { seqid: 118, Book: "Ephesians", Chapter: "3", Verse: "8" },
  { seqid: 119, Book: "Colossians", Chapter: "1", Verse: "25" },
  { seqid: 120, Book: "Romans", Chapter: "9", Verse: "5" },
  { seqid: 121, Book: "Isaiah", Chapter: "9", Verse: "6" },
  { seqid: 122, Book: "John", Chapter: "1", Verse: "1" },
  { seqid: 123, Book: "John", Chapter: "1", Verse: "14" },
  { seqid: 124, Book: "Colossians", Chapter: "2", Verse: "9" },
  { seqid: 125, Book: "Colossians", Chapter: "1", Verse: "19" },
  { seqid: 126, Book: "John", Chapter: "1", Verse: "16" },
  { seqid: 127, Book: "Hebrews", Chapter: "1", Verse: "3" },
  { seqid: 128, Book: "Colossians", Chapter: "1", Verse: "15" },
  { seqid: 129, Book: "Colossians", Chapter: "1", Verse: "16" },
  { seqid: 130, Book: "Colossians", Chapter: "1", Verse: "17" },
  { seqid: 131, Book: "Colossians", Chapter: "1", Verse: "18" },
  { seqid: 132, Book: "John", Chapter: "20", Verse: "31" },
  { seqid: 133, Book: "I Timothy", Chapter: "3", Verse: "16" },
  { seqid: 134, Book: "Romans", Chapter: "8", Verse: "3" },
  { seqid: 135, Book: "I Timothy", Chapter: "2", Verse: "5" },
  { seqid: 136, Book: "Genesis", Chapter: "3", Verse: "15" },
  { seqid: 137, Book: "Galatians", Chapter: "3", Verse: "16" },
  { seqid: 138, Book: "Romans", Chapter: "1", Verse: "3" },
  { seqid: 139, Book: "Romans", Chapter: "1", Verse: "4" },
  { seqid: 140, Book: "Matthew", Chapter: "1", Verse: "21" },
  { seqid: 141, Book: "Matthew", Chapter: "1", Verse: "23" },
  { seqid: 142, Book: "Hebrews", Chapter: "2", Verse: "17" },
  { seqid: 143, Book: "Hebrews", Chapter: "4", Verse: "15" },
  { seqid: 144, Book: "John", Chapter: "1", Verse: "18" },
  { seqid: 145, Book: "Philippians", Chapter: "2", Verse: "6" },
  { seqid: 146, Book: "Philippians", Chapter: "2", Verse: "7" },
  { seqid: 147, Book: "Philippians", Chapter: "2", Verse: "8" },
  { seqid: 148, Book: "Hebrews", Chapter: "2", Verse: "14" },
  { seqid: 149, Book: "Acts", Chapter: "2", Verse: "23" },
  { seqid: 150, Book: "I Peter", Chapter: "2", Verse: "24" },
  { seqid: 151, Book: "Isaiah", Chapter: "3", Verse: "5" },
  { seqid: 152, Book: "Isaiah", Chapter: "3", Verse: "6" },
  { seqid: 153, Book: "John", Chapter: "1", Verse: "29" },
  { seqid: 154, Book: "I Corinthians", Chapter: "5", Verse: "7" },
  { seqid: 155, Book: "John", Chapter: "3", Verse: "14" },
  { seqid: 156, Book: "Romans", Chapter: "6", Verse: "6" },
  { seqid: 157, Book: "Galatians", Chapter: "5", Verse: "24" },
  { seqid: 158, Book: "Colossians", Chapter: "1", Verse: "20" },
  { seqid: 159, Book: "Ephesians", Chapter: "2", Verse: "15" },
  { seqid: 160, Book: "John", Chapter: "12", Verse: "24" },
  { seqid: 161, Book: "John", Chapter: "19", Verse: "34" },
  { seqid: 162, Book: "II Timothy", Chapter: "1", Verse: "10" },
  { seqid: 163, Book: "Acts", Chapter: "3", Verse: "15" },
  { seqid: 164, Book: "Acts", Chapter: "13", Verse: "33" },
  { seqid: 165, Book: "I Corinthians", Chapter: "15", Verse: "45" },
  { seqid: 166, Book: "I Peter", Chapter: "1", Verse: "3" },
  { seqid: 167, Book: "Revelation of John", Chapter: "1", Verse: "5" },
  { seqid: 168, Book: "Ephesians", Chapter: "1", Verse: "20" },
  { seqid: 169, Book: "Ephesians", Chapter: "1", Verse: "21" },
  { seqid: 170, Book: "Ephesians", Chapter: "1", Verse: "22" },
  { seqid: 171, Book: "Acts", Chapter: "2", Verse: "36" },
  { seqid: 172, Book: "Revelation of John", Chapter: "5", Verse: "5" },
  { seqid: 173, Book: "Hebrews", Chapter: "12", Verse: "24" },
  { seqid: 174, Book: "Hebrews", Chapter: "7", Verse: "22" },
  { seqid: 175, Book: "Ephesians", Chapter: "4", Verse: "8" },
  { seqid: 176, Book: "I Peter", Chapter: "2", Verse: "4" },
  { seqid: 177, Book: "Isaiah", Chapter: "8", Verse: "16" },
  { seqid: 178, Book: "Isaiah", Chapter: "8", Verse: "14" },
  { seqid: 179, Book: "Daniel", Chapter: "2", Verse: "35" },
  { seqid: 180, Book: "Hebrews", Chapter: "6", Verse: "20" },
  { seqid: 181, Book: "Hebrews", Chapter: "7", Verse: "25" },
  { seqid: 182, Book: "Revelation of John", Chapter: "1", Verse: "13" },
  { seqid: 183, Book: "Matthew", Chapter: "17", Verse: "5" },
  { seqid: 184, Book: "Colossians", Chapter: "1", Verse: "12" },
  { seqid: 185, Book: "I Corinthians", Chapter: "10", Verse: "4" },
  { seqid: 186, Book: "Colossians", Chapter: "2", Verse: "16" },
  { seqid: 187, Book: "Colossians", Chapter: "2", Verse: "17" },
  { seqid: 188, Book: "I Corinthians", Chapter: "1", Verse: "24" },
  { seqid: 189, Book: "I Corinthians", Chapter: "1", Verse: "30" },
  { seqid: 190, Book: "John", Chapter: "7", Verse: "38" },
  { seqid: 191, Book: "John", Chapter: "7", Verse: "39" },
  { seqid: 192, Book: "Revelation of John", Chapter: "2", Verse: "17" },
  { seqid: 193, Book: "Galatians", Chapter: "3", Verse: "14" },
  { seqid: 194, Book: "John", Chapter: "14", Verse: "26" },
  { seqid: 195, Book: "Colossians", Chapter: "2", Verse: "9" },
  { seqid: 196, Book: "John", Chapter: "16", Verse: "15" },
  { seqid: 197, Book: "John", Chapter: "14", Verse: "17" },
  { seqid: 198, Book: "John", Chapter: "14", Verse: "20" },
  { seqid: 199, Book: "Matthew", Chapter: "1", Verse: "18" },
  { seqid: 200, Book: "Luke", Chapter: "3", Verse: "22" },
  { seqid: 201, Book: "John", Chapter: "20", Verse: "22" },
  { seqid: 202, Book: "Galatians", Chapter: "5", Verse: "25" },
  { seqid: 203, Book: "Acts", Chapter: "1", Verse: "8" },
  { seqid: 204, Book: "Zechariah", Chapter: "4", Verse: "6" },
  { seqid: 205, Book: "Genesis", Chapter: "1", Verse: "2" },
  { seqid: 206, Book: "I Corinthians", Chapter: "2", Verse: "11" },
  { seqid: 207, Book: "Ezekiel", Chapter: "11", Verse: "5" },
  { seqid: 208, Book: "Matthew", Chapter: "1", Verse: "20" },
  { seqid: 209, Book: "John", Chapter: "7", Verse: "39" },
  { seqid: 210, Book: "I Corinthians", Chapter: "15", Verse: "45" },
  { seqid: 211, Book: "Romans", Chapter: "8", Verse: "2" },
  { seqid: 212, Book: "John", Chapter: "16", Verse: "13" },
  { seqid: 213, Book: "Acts", Chapter: "16", Verse: "7" },
  { seqid: 214, Book: "Romans", Chapter: "8", Verse: "9" },
  { seqid: 215, Book: "Philippians", Chapter: "1", Verse: "19" },
  { seqid: 216, Book: "Philippians", Chapter: "1", Verse: "20" },
  { seqid: 217, Book: "Philippians", Chapter: "1", Verse: "21" },
  { seqid: 218, Book: "II Corinthians", Chapter: "3", Verse: "17" },
  { seqid: 219, Book: "II Corinthians", Chapter: "3", Verse: "18" },
  { seqid: 220, Book: "I John", Chapter: "2", Verse: "27" },
  { seqid: 221, Book: "Revelation of John", Chapter: "1", Verse: "4" },
  { seqid: 222, Book: "John", Chapter: "15", Verse: "26" },
  { seqid: 223, Book: "John", Chapter: "16", Verse: "8" },
  { seqid: 224, Book: "John", Chapter: "3", Verse: "6" },
  { seqid: 225, Book: "Romans", Chapter: "8", Verse: "16" },
  { seqid: 226, Book: "Romans", Chapter: "8", Verse: "15" },
  { seqid: 227, Book: "Romans", Chapter: "8", Verse: "14" },
  { seqid: 228, Book: "I Corinthians", Chapter: "6", Verse: "17" },
  { seqid: 229, Book: "I Peter", Chapter: "1", Verse: "2" },
  { seqid: 230, Book: "I Corinthians", Chapter: "6", Verse: "11" },
  { seqid: 231, Book: "Romans", Chapter: "6", Verse: "19" },
  { seqid: 232, Book: "Romans", Chapter: "8", Verse: "11" },
  { seqid: 233, Book: "I Corinthians", Chapter: "2", Verse: "12" },
  { seqid: 234, Book: "Romans", Chapter: "8", Verse: "13" },
  { seqid: 235, Book: "Ephesians", Chapter: "3", Verse: "16" },
  { seqid: 236, Book: "Romans", Chapter: "8", Verse: "26" },
  { seqid: 237, Book: "Ephesians", Chapter: "1", Verse: "13" },
  { seqid: 238, Book: "Ephesians", Chapter: "1", Verse: "14" },
  { seqid: 239, Book: "II Corinthians", Chapter: "13", Verse: "14" },
  { seqid: 240, Book: "John", Chapter: "3", Verse: "16" },
  { seqid: 241, Book: "Mark", Chapter: "16", Verse: "16" },
  { seqid: 242, Book: "Acts", Chapter: "16", Verse: "31" },
  { seqid: 243, Book: "Ephesians", Chapter: "2", Verse: "5" },
  { seqid: 244, Book: "Ephesians", Chapter: "2", Verse: "8" },
  { seqid: 245, Book: "Ephesians", Chapter: "1", Verse: "4" },
  { seqid: 246, Book: "Ephesians", Chapter: "1", Verse: "5" },
  { seqid: 247, Book: "Ephesians", Chapter: "1", Verse: "3" },
  { seqid: 248, Book: "Ephesians", Chapter: "1", Verse: "11" },
  { seqid: 249, Book: "Ephesians", Chapter: "1", Verse: "14" },
  { seqid: 250, Book: "Jeremiah", Chapter: "2", Verse: "13" },
  { seqid: 251, Book: "John", Chapter: "16", Verse: "9" },
  { seqid: 252, Book: "Romans", Chapter: "3", Verse: "23" },
  { seqid: 253, Book: "Romans", Chapter: "5", Verse: "12" },
  { seqid: 254, Book: "Romans", Chapter: "6", Verse: "23" },
  { seqid: 255, Book: "II Corinthians", Chapter: "4", Verse: "6" },
  { seqid: 256, Book: "Ephesians", Chapter: "2", Verse: "12" },
  { seqid: 257, Book: "Ephesians", Chapter: "2", Verse: "13" },
  { seqid: 258, Book: "Ephesians", Chapter: "2", Verse: "17" },
  { seqid: 259, Book: "Acts", Chapter: "10", Verse: "43" },
  { seqid: 260, Book: "Isaiah", Chapter: "1", Verse: "18" },
  { seqid: 261, Book: "John", Chapter: "1", Verse: "12" },
  { seqid: 262, Book: "Galatians", Chapter: "3", Verse: "24" },
  { seqid: 263, Book: "Galatians", Chapter: "3", Verse: "5" },
  { seqid: 264, Book: "Ephesians", Chapter: "2", Verse: "6" },
  { seqid: 265, Book: "John", Chapter: "5", Verse: "24" },
  { seqid: 266, Book: "I John", Chapter: "5", Verse: "12" },
  { seqid: 267, Book: "I John", Chapter: "5", Verse: "13" },
  { seqid: 268, Book: "Romans", Chapter: "8", Verse: "16" },
  { seqid: 269, Book: "I John", Chapter: "3", Verse: "14" },
  { seqid: 270, Book: "Psalms", Chapter: "1", Verse: "12" },
  { seqid: 271, Book: "Isaiah", Chapter: "12", Verse: "2" },
  { seqid: 272, Book: "I Thessalonians", Chapter: "1", Verse: "9" },
  { seqid: 273, Book: "Galatians", Chapter: "4", Verse: "6" },
  { seqid: 274, Book: "I John", Chapter: "3", Verse: "2" },
  { seqid: 275, Book: "Galatians", Chapter: "4", Verse: "7" },
  { seqid: 276, Book: "I John", Chapter: "5", Verse: "4" },
  { seqid: 277, Book: "Ephesians", Chapter: "4", Verse: "6" },
  { seqid: 278, Book: "Colossians", Chapter: "1", Verse: "27" },
  { seqid: 279, Book: "II Timothy", Chapter: "1", Verse: "14" },
  { seqid: 280, Book: "Philippians", Chapter: "2", Verse: "15" },
  { seqid: 281, Book: "Matthew", Chapter: "5", Verse: "14" },
  { seqid: 282, Book: "Matthew", Chapter: "5", Verse: "16" },
  { seqid: 283, Book: "Matthew", Chapter: "5", Verse: "13" },
  { seqid: 284, Book: "II Timothy", Chapter: "1", Verse: "9" },
  { seqid: 285, Book: "Philippians", Chapter: "3", Verse: "20" },
  { seqid: 286, Book: "Matthew", Chapter: "4", Verse: "42" },
  { seqid: 287, Book: "Titus", Chapter: "2", Verse: "13" },
  { seqid: 288, Book: "II Peter", Chapter: "3", Verse: "8" },
  { seqid: 289, Book: "II Peter", Chapter: "3", Verse: "9" },
  { seqid: 290, Book: "II Timothy", Chapter: "4", Verse: "8" },
  { seqid: 291, Book: "I Corinthians", Chapter: "15", Verse: "52" },
  { seqid: 292, Book: "II Corinthians", Chapter: "5", Verse: "10" },
  { seqid: 293, Book: "Revelation of John", Chapter: "14", Verse: "4" },
  { seqid: 294, Book: "Revelation of John", Chapter: "12", Verse: "5" },
  { seqid: 295, Book: "Revelation of John", Chapter: "2", Verse: "10" },
  { seqid: 296, Book: "Revelation of John", Chapter: "3", Verse: "8" },
  { seqid: 297, Book: "Ephesians", Chapter: "3", Verse: "10" },
  { seqid: 298, Book: "Ephesians", Chapter: "3", Verse: "11" },
  { seqid: 299, Book: "Acts", Chapter: "17", Verse: "24" },
  { seqid: 300, Book: "Colossians", Chapter: "2", Verse: "2" },
  { seqid: 301, Book: "Ephesians", Chapter: "3", Verse: "4" },
  { seqid: 302, Book: "Ephesians", Chapter: "5", Verse: "32" },
  { seqid: 303, Book: "Ephesians", Chapter: "2", Verse: "10" },
  { seqid: 304, Book: "Romans", Chapter: "16", Verse: "20" },
  { seqid: 305, Book: "Matthew", Chapter: "16", Verse: "18" },
  { seqid: 306, Book: "Genesis", Chapter: "2", Verse: "22" },
  { seqid: 307, Book: "Genesis", Chapter: "2", Verse: "23" },
  { seqid: 308, Book: "Ephesians", Chapter: "1", Verse: "22" },
  { seqid: 309, Book: "Ephesians", Chapter: "1", Verse: "23" },
  { seqid: 310, Book: "I Timothy", Chapter: "3", Verse: "15" },
  { seqid: 311, Book: "I Timothy", Chapter: "3", Verse: "16" },
  { seqid: 312, Book: "Ephesians", Chapter: "2", Verse: "19" },
  { seqid: 313, Book: "Ephesians", Chapter: "2", Verse: "21" },
  { seqid: 314, Book: "Ephesians", Chapter: "2", Verse: "22" },
  { seqid: 315, Book: "Psalms", Chapter: "6", Verse: "8" },
  { seqid: 316, Book: "Ephesians", Chapter: "5", Verse: "25" },
  { seqid: 317, Book: "Ephesians", Chapter: "2", Verse: "15" },
  { seqid: 318, Book: "Colossians", Chapter: "3", Verse: "10" },
  { seqid: 319, Book: "Colossians", Chapter: "3", Verse: "11" },
  { seqid: 320, Book: "Ephesians", Chapter: "6", Verse: "13" },
  { seqid: 321, Book: "Revelation of John", Chapter: "1", Verse: "20" },
  { seqid: 322, Book: "Ephesians", Chapter: "2", Verse: "22" },
  { seqid: 323, Book: "Matthew", Chapter: "18", Verse: "17" },
  { seqid: 324, Book: "Matthew", Chapter: "18", Verse: "18" },
  { seqid: 325, Book: "Matthew", Chapter: "18", Verse: "17" },
  { seqid: 326, Book: "Matthew", Chapter: "18", Verse: "18" },
  { seqid: 327, Book: "Matthew", Chapter: "18", Verse: "19" },
  { seqid: 328, Book: "I Corinthians", Chapter: "1", Verse: "2" },
  { seqid: 329, Book: "Romans", Chapter: "16", Verse: "16" },
  { seqid: 330, Book: "I Corinthians", Chapter: "14", Verse: "34" },
  { seqid: 331, Book: "Deuteronomy", Chapter: "16", Verse: "16" },
  { seqid: 332, Book: "Acts", Chapter: "14", Verse: "23" },
  { seqid: 333, Book: "Titus", Chapter: "1", Verse: "5" },
  { seqid: 334, Book: "Revelation of John", Chapter: "1", Verse: "11" },
  { seqid: 335, Book: "Acts", Chapter: "5", Verse: "42" },
  { seqid: 336, Book: "Acts", Chapter: "2", Verse: "42" },
  { seqid: 337, Book: "Acts", Chapter: "20", Verse: "7" },
  { seqid: 338, Book: "Hebrews", Chapter: "2", Verse: "12" },
  { seqid: 339, Book: "Acts", Chapter: "4", Verse: "31" },
  { seqid: 340, Book: "Philippians", Chapter: "1", Verse: "1" },
  { seqid: 341, Book: "Acts", Chapter: "20", Verse: "17" },
  { seqid: 342, Book: "Acts", Chapter: "20", Verse: "28" },
  { seqid: 343, Book: "Acts", Chapter: "13", Verse: "1" },
  { seqid: 344, Book: "Revelation of John", Chapter: "2", Verse: "6" },
  { seqid: 345, Book: "I Corinthians", Chapter: "14", Verse: "26" },
  { seqid: 346, Book: "I Corinthians", Chapter: "14", Verse: "4" },
  { seqid: 347, Book: "Psalms", Chapter: "3", Verse: "1" },
  { seqid: 348, Book: "Psalms", Chapter: "3", Verse: "2" },
  { seqid: 349, Book: "Psalms", Chapter: "3", Verse: "3" },
  { seqid: 350, Book: "Revelation of John", Chapter: "3", Verse: "7" },
  { seqid: 351, Book: "I Corinthians", Chapter: "8", Verse: "1" },
  { seqid: 352, Book: "I Corinthians", Chapter: "12", Verse: "31" },
  { seqid: 353, Book: "I Corinthians", Chapter: "13", Verse: "13" },
  { seqid: 354, Book: "Hebrews", Chapter: "12", Verse: "22" },
  { seqid: 355, Book: "Hebrews", Chapter: "12", Verse: "23" },
  { seqid: 356, Book: "Ephesians", Chapter: "4", Verse: "4" },
  { seqid: 357, Book: "Ephesians", Chapter: "4", Verse: "5" },
  { seqid: 358, Book: "Ephesians", Chapter: "4", Verse: "6" },
  { seqid: 359, Book: "I Corinthians", Chapter: "12", Verse: "13" },
  { seqid: 360, Book: "Ephesians", Chapter: "2", Verse: "14" },
  { seqid: 361, Book: "Ephesians", Chapter: "2", Verse: "16" },
  { seqid: 362, Book: "Colossians", Chapter: "1", Verse: "18" },
  { seqid: 363, Book: "I Corinthians", Chapter: "12", Verse: "12" },
  { seqid: 364, Book: "Romans", Chapter: "12", Verse: "4" },
  { seqid: 365, Book: "Romans", Chapter: "12", Verse: "5" },
  { seqid: 366, Book: "I Corinthians", Chapter: "12", Verse: "22" },
  { seqid: 367, Book: "I Corinthians", Chapter: "12", Verse: "24" },
  { seqid: 368, Book: "I Corinthians", Chapter: "12", Verse: "25" },
  { seqid: 369, Book: "I Corinthians", Chapter: "12", Verse: "26" },
  { seqid: 370, Book: "Ephesians", Chapter: "4", Verse: "11" },
  { seqid: 371, Book: "I Corinthians", Chapter: "12", Verse: "28" },
  { seqid: 372, Book: "Romans", Chapter: "12", Verse: "6" },
  { seqid: 373, Book: "Ephesians", Chapter: "4", Verse: "7" },
  { seqid: 374, Book: "Ephesians", Chapter: "4", Verse: "12" },
  { seqid: 375, Book: "Ephesians", Chapter: "4", Verse: "13" },
  { seqid: 376, Book: "Ephesians", Chapter: "4", Verse: "14" },
  { seqid: 377, Book: "Ephesians", Chapter: "4", Verse: "15" },
  { seqid: 378, Book: "Ephesians", Chapter: "4", Verse: "16" },
  { seqid: 379, Book: "Colossians", Chapter: "2", Verse: "19" },
  { seqid: 380, Book: "I Corinthians", Chapter: "10", Verse: "16" },
  { seqid: 381, Book: "I Corinthians", Chapter: "10", Verse: "17" },
  { seqid: 382, Book: "Romans", Chapter: "12", Verse: "3" },
  { seqid: 383, Book: "I Corinthians", Chapter: "1", Verse: "12" },
  { seqid: 384, Book: "I Corinthians", Chapter: "1", Verse: "10" },
  { seqid: 385, Book: "Romans", Chapter: "15", Verse: "6" },
  { seqid: 386, Book: "Romans", Chapter: "15", Verse: "7" },
  { seqid: 387, Book: "Ephesians", Chapter: "4", Verse: "3" },
  { seqid: 388, Book: "Romans", Chapter: "16", Verse: "17" },
  { seqid: 389, Book: "Colossians", Chapter: "1", Verse: "24" },
  { seqid: 390, Book: "Matthew", Chapter: "6", Verse: "33" },
  { seqid: 391, Book: "Matthew", Chapter: "6", Verse: "10" },
  { seqid: 392, Book: "Matthew", Chapter: "6", Verse: "13" },
  { seqid: 393, Book: "Romans", Chapter: "14", Verse: "17" },
  { seqid: 394, Book: "Luke", Chapter: "17", Verse: "21" },
  { seqid: 395, Book: "Matthew", Chapter: "13", Verse: "37" },
  { seqid: 396, Book: "Mark", Chapter: "4", Verse: "14" },
  { seqid: 397, Book: "Mark", Chapter: "1", Verse: "15" },
  { seqid: 398, Book: "John", Chapter: "3", Verse: "3" },
  { seqid: 399, Book: "John", Chapter: "3", Verse: "5" },
  { seqid: 400, Book: "Mark", Chapter: "4", Verse: "26" },
  { seqid: 401, Book: "Mark", Chapter: "4", Verse: "27" },
  { seqid: 402, Book: "II Peter", Chapter: "1", Verse: "4" },
  { seqid: 403, Book: "II Peter", Chapter: "1", Verse: "11" },
  { seqid: 404, Book: "Colossians", Chapter: "1", Verse: "13" },
  { seqid: 405, Book: "Acts", Chapter: "6", Verse: "18" },
  { seqid: 406, Book: "Daniel", Chapter: "4", Verse: "26" },
  { seqid: 407, Book: "Matthew", Chapter: "5", Verse: "3" },
  { seqid: 408, Book: "Matthew", Chapter: "16", Verse: "18" },
  { seqid: 409, Book: "Matthew", Chapter: "12", Verse: "28" },
  { seqid: 410, Book: "Ephesians", Chapter: "6", Verse: "12" },
  { seqid: 411, Book: "Isaiah", Chapter: "14", Verse: "13" },
  { seqid: 412, Book: "Ephesians", Chapter: "6", Verse: "11" },
  { seqid: 413, Book: "Romans", Chapter: "13", Verse: "12" },
  { seqid: 414, Book: "Nehemiah", Chapter: "4", Verse: "17" },
  { seqid: 415, Book: "Numbers", Chapter: "10", Verse: "35" },
  { seqid: 416, Book: "Revelation of John", Chapter: "1", Verse: "6" },
  { seqid: 417, Book: "Hebrews", Chapter: "12", Verse: "28" },
  { seqid: 418, Book: "I Thessalonians", Chapter: "2", Verse: "12" },
  { seqid: 419, Book: "Matthew", Chapter: "7", Verse: "21" },
  { seqid: 420, Book: "Acts", Chapter: "14", Verse: "22" },
  { seqid: 421, Book: "II Timothy", Chapter: "2", Verse: "12" },
  { seqid: 422, Book: "Revelation of John", Chapter: "12", Verse: "10" },
  { seqid: 423, Book: "Revelation of John", Chapter: "12", Verse: "11" },
  { seqid: 424, Book: "Revelation of John", Chapter: "19", Verse: "8" },
  { seqid: 425, Book: "Daniel", Chapter: "2", Verse: "34" },
  { seqid: 426, Book: "Daniel", Chapter: "2", Verse: "35" },
  { seqid: 427, Book: "Revelation of John", Chapter: "11", Verse: "15" },
  { seqid: 428, Book: "Revelation of John", Chapter: "20", Verse: "6" },
  { seqid: 429, Book: "Revelation of John", Chapter: "1", Verse: "1" },
  { seqid: 430, Book: "Revelation of John", Chapter: "1", Verse: "2" },
  { seqid: 431, Book: "Revelation of John", Chapter: "1", Verse: "5" },
  { seqid: 432, Book: "Revelation of John", Chapter: "1", Verse: "1" },
  { seqid: 433, Book: "Revelation of John", Chapter: "1", Verse: "2" },
  { seqid: 434, Book: "Revelation of John", Chapter: "1", Verse: "5" },
  { seqid: 435, Book: "Revelation of John", Chapter: "1", Verse: "9" },
  { seqid: 436, Book: "Revelation of John", Chapter: "1", Verse: "10" },
  { seqid: 437, Book: "Revelation of John", Chapter: "1", Verse: "11" },
  { seqid: 438, Book: "John", Chapter: "2", Verse: "19" },
  { seqid: 439, Book: "John", Chapter: "2", Verse: "21" },
  { seqid: 440, Book: "John", Chapter: "14", Verse: "2" },
  { seqid: 441, Book: "John", Chapter: "14", Verse: "23" },
  { seqid: 442, Book: "Revelation of John", Chapter: "2", Verse: "17" },
  { seqid: 443, Book: "Romans", Chapter: "8", Verse: "29" },
  { seqid: 444, Book: "Hebrews", Chapter: "2", Verse: "10" },
  { seqid: 445, Book: "Revelation of John", Chapter: "1", Verse: "7" },
  { seqid: 446, Book: "Revelation of John", Chapter: "4", Verse: "3" },
  { seqid: 447, Book: "Revelation of John", Chapter: "1", Verse: "11" },
  { seqid: 448, Book: "Revelation of John", Chapter: "1", Verse: "18" },
  { seqid: 449, Book: "Galatians", Chapter: "4", Verse: "26" },
  { seqid: 450, Book: "Hebrews", Chapter: "11", Verse: "10" },
  { seqid: 451, Book: "Hebrews", Chapter: "12", Verse: "22" },
  { seqid: 452, Book: "II Corinthians", Chapter: "5", Verse: "17" },
  { seqid: 453, Book: "Revelation of John", Chapter: "1", Verse: "3" },
  { seqid: 454, Book: "I Corinthians", Chapter: "3", Verse: "16" },
  { seqid: 455, Book: "Revelation of John", Chapter: "1", Verse: "22" },
  { seqid: 456, Book: "Revelation of John", Chapter: "3", Verse: "12" },
  { seqid: 457, Book: "Revelation of John", Chapter: "1", Verse: "12" },
  { seqid: 458, Book: "Revelation of John", Chapter: "1", Verse: "14" },
  { seqid: 459, Book: "Revelation of John", Chapter: "1", Verse: "18" },
  { seqid: 460, Book: "Revelation of John", Chapter: "1", Verse: "21" },
  { seqid: 461, Book: "Revelation of John", Chapter: "1", Verse: "19" },
  { seqid: 462, Book: "Revelation of John", Chapter: "1", Verse: "16" },
  { seqid: 463, Book: "Revelation of John", Chapter: "1", Verse: "17" },
  { seqid: 464, Book: "Revelation of John", Chapter: "2", Verse: "1" },
  { seqid: 465, Book: "Revelation of John", Chapter: "2", Verse: "2" },
  { seqid: 466, Book: "Revelation of John", Chapter: "2", Verse: "14" },
  { seqid: 467, Book: "Revelation of John", Chapter: "1", Verse: "20" },
  { seqid: 468, Book: "Revelation of John", Chapter: "1", Verse: "23" },
  { seqid: 469, Book: "Revelation of John", Chapter: "2", Verse: "5" },
  { seqid: 470, Book: "Psalms", Chapter: "6", Verse: "9" },
  { seqid: 471, Book: "John", Chapter: "1", Verse: "4" },
  { seqid: 472, Book: "John", Chapter: "11", Verse: "25" },
  { seqid: 473, Book: "John", Chapter: "14", Verse: "6" },
  { seqid: 474, Book: "Colossians", Chapter: "3", Verse: "4" },
  { seqid: 475, Book: "I John", Chapter: "5", Verse: "12" },
  { seqid: 476, Book: "John", Chapter: "6", Verse: "63" },
  { seqid: 477, Book: "II Corinthians", Chapter: "3", Verse: "6" },
  { seqid: 478, Book: "John", Chapter: "10", Verse: "28" },
  { seqid: 479, Book: "Hebrews", Chapter: "7", Verse: "16" },
  { seqid: 480, Book: "John", Chapter: "10", Verse: "10" },
  { seqid: 481, Book: "John", Chapter: "10", Verse: "11" },
  { seqid: 482, Book: "I John", Chapter: "5", Verse: "13" },
  { seqid: 483, Book: "Genesis", Chapter: "2", Verse: "9" },
  { seqid: 484, Book: "Revelation of John", Chapter: "2", Verse: "2" },
  { seqid: 485, Book: "Revelation of John", Chapter: "2", Verse: "1" },
  { seqid: 486, Book: "John", Chapter: "6", Verse: "51" },
  { seqid: 487, Book: "John", Chapter: "6", Verse: "35" },
  { seqid: 488, Book: "I John", Chapter: "1", Verse: "1" },
  { seqid: 489, Book: "I John", Chapter: "5", Verse: "39" },
  { seqid: 490, Book: "Ezekiel", Chapter: "6", Verse: "26" },
  { seqid: 491, Book: "Philippians", Chapter: "2", Verse: "13" },
  { seqid: 492, Book: "Galatians", Chapter: "1", Verse: "15" },
  { seqid: 493, Book: "Galatians", Chapter: "1", Verse: "16" },
  { seqid: 494, Book: "Galatians", Chapter: "2", Verse: "20" },
  { seqid: 495, Book: "Galatians", Chapter: "4", Verse: "19" },
  { seqid: 496, Book: "Philippians", Chapter: "3", Verse: "9" },
  { seqid: 497, Book: "Philippians", Chapter: "1", Verse: "20" },
  { seqid: 498, Book: "Romans", Chapter: "8", Verse: "2" },
  { seqid: 499, Book: "I John", Chapter: "2", Verse: "27" },
  { seqid: 500, Book: "Romans", Chapter: "6", Verse: "11" },
  { seqid: 501, Book: "Galatians", Chapter: "6", Verse: "14" },
  { seqid: 502, Book: "I John", Chapter: "2", Verse: "15" },
  { seqid: 503, Book: "Romans", Chapter: "12", Verse: "2" },
  { seqid: 504, Book: "Galatians", Chapter: "1", Verse: "4" },
  { seqid: 505, Book: "Galatians", Chapter: "5", Verse: "24" },
  { seqid: 506, Book: "Matthew", Chapter: "16", Verse: "24" },
  { seqid: 507, Book: "Job", Chapter: "2", Verse: "5" },
  { seqid: 508, Book: "Job", Chapter: "2", Verse: "6" },
  { seqid: 509, Book: "Genesis", Chapter: "13", Verse: "15" },
  { seqid: 510, Book: "Romans", Chapter: "8", Verse: "13" },
  { seqid: 511, Book: "II Corinthians", Chapter: "4", Verse: "10" },
  { seqid: 512, Book: "II Corinthians", Chapter: "4", Verse: "12" },
  { seqid: 513, Book: "Ephesians", Chapter: "3", Verse: "17" },
  { seqid: 514, Book: "Romans", Chapter: "8", Verse: "5" },
  { seqid: 515, Book: "Romans", Chapter: "8", Verse: "6" },
  { seqid: 516, Book: "John", Chapter: "8", Verse: "36" },
  { seqid: 517, Book: "I John", Chapter: "3", Verse: "9" },
  { seqid: 518, Book: "Colossians", Chapter: "3", Verse: "15" },
  { seqid: 519, Book: "Romans", Chapter: "8", Verse: "4" },
  { seqid: 520, Book: "Philippians", Chapter: "2", Verse: "12" },
  { seqid: 521, Book: "Hebrews", Chapter: "10", Verse: "19" },
  { seqid: 522, Book: "John", Chapter: "4", Verse: "23" },
  { seqid: 523, Book: "I John", Chapter: "1", Verse: "7" },
  { seqid: 524, Book: "I John", Chapter: "1", Verse: "9" },
  { seqid: 525, Book: "Acts", Chapter: "4", Verse: "16" },
  { seqid: 526, Book: "I Timothy", Chapter: "1", Verse: "5" },
  { seqid: 527, Book: "I John", Chapter: "3", Verse: "20" },
  { seqid: 528, Book: "I John", Chapter: "1", Verse: "2" },
  { seqid: 529, Book: "I John", Chapter: "1", Verse: "3" },
  { seqid: 530, Book: "Philippians", Chapter: "1", Verse: "5" },
  { seqid: 531, Book: "Colossians", Chapter: "3", Verse: "13" },
  { seqid: 532, Book: "Hebrews", Chapter: "6", Verse: "1" },
  { seqid: 533, Book: "I Corinthians", Chapter: "3", Verse: "6" },
  { seqid: 534, Book: "Colossians", Chapter: "2", Verse: "19" },
  { seqid: 535, Book: "I Corinthians", Chapter: "3", Verse: "1" },
  { seqid: 536, Book: "I Peter", Chapter: "2", Verse: "2" },
  { seqid: 537, Book: "Hebrews", Chapter: "5", Verse: "13" },
  { seqid: 538, Book: "Hebrews", Chapter: "5", Verse: "14" },
  { seqid: 539, Book: "I Corinthians", Chapter: "14", Verse: "20" },
  { seqid: 540, Book: "Ephesians", Chapter: "2", Verse: "21" },
  { seqid: 541, Book: "Ephesians", Chapter: "2", Verse: "22" },
  { seqid: 542, Book: "Romans", Chapter: "10", Verse: "13" },
  { seqid: 543, Book: "Acts", Chapter: "2", Verse: "21" },
  { seqid: 544, Book: "Romans", Chapter: "10", Verse: "12" },
  { seqid: 545, Book: "Genesis", Chapter: "4", Verse: "26" },
  { seqid: 546, Book: "I Corinthians", Chapter: "12", Verse: "3" },
  { seqid: 547, Book: "Isaiah", Chapter: "12", Verse: "3" },
  { seqid: 548, Book: "Isaiah", Chapter: "12", Verse: "4" },
  { seqid: 549, Book: "Psalms", Chapter: "6", Verse: "13" },
  { seqid: 550, Book: "Lamentations", Chapter: "3", Verse: "55" },
  { seqid: 551, Book: "Lamentations", Chapter: "3", Verse: "56" },
  { seqid: 552, Book: "Isaiah", Chapter: "5", Verse: "6" },
  { seqid: 553, Book: "Psalms", Chapter: "5", Verse: "18" },
  { seqid: 554, Book: "Psalms", Chapter: "1", Verse: "10" },
  { seqid: 555, Book: "Psalms", Chapter: "8", Verse: "9" },
  { seqid: 556, Book: "Philippians", Chapter: "2", Verse: "9" },
  { seqid: 557, Book: "Philippians", Chapter: "2", Verse: "10" },
  { seqid: 558, Book: "Philippians", Chapter: "2", Verse: "11" },
  { seqid: 559, Book: "I Corinthians", Chapter: "1", Verse: "2" },
  { seqid: 560, Book: "I Thessalonians", Chapter: "5", Verse: "17" },
  { seqid: 561, Book: "I Thessalonians", Chapter: "5", Verse: "18" },
  { seqid: 562, Book: "Philippians", Chapter: "4", Verse: "6" },
  { seqid: 563, Book: "Romans", Chapter: "8", Verse: "26" },
  { seqid: 564, Book: "Matthew", Chapter: "6", Verse: "9" },
  { seqid: 565, Book: "James", Chapter: "5", Verse: "17" },
  { seqid: 566, Book: "Ephesians", Chapter: "6", Verse: "18" },
  { seqid: 567, Book: "I Timothy", Chapter: "2", Verse: "8" },
  { seqid: 568, Book: "Hebrews", Chapter: "4", Verse: "16" },
  { seqid: 569, Book: "Matthew", Chapter: "6", Verse: "6" },
  { seqid: 570, Book: "Daniel", Chapter: "6", Verse: "10" },
  { seqid: 571, Book: "Matthew", Chapter: "18", Verse: "19" },
  { seqid: 572, Book: "Matthew", Chapter: "18", Verse: "20" },
  { seqid: 573, Book: "Mark", Chapter: "11", Verse: "23" },
  { seqid: 574, Book: "Mark", Chapter: "11", Verse: "24" },
  { seqid: 575, Book: "Matthew", Chapter: "18", Verse: "18" },
  { seqid: 576, Book: "Acts", Chapter: "1", Verse: "14" },
  { seqid: 577, Book: "Acts", Chapter: "6", Verse: "4" },
  { seqid: 578, Book: "Colossians", Chapter: "4", Verse: "2" },
  { seqid: 579, Book: "Matthew", Chapter: "17", Verse: "21" },
  { seqid: 580, Book: "Matthew", Chapter: "6", Verse: "41" },
  { seqid: 581, Book: "Isaiah", Chapter: "2", Verse: "6" },
  { seqid: 582, Book: "Ephesians", Chapter: "6", Verse: "18" },
  { seqid: 583, Book: "Ephesians", Chapter: "6", Verse: "19" },
  { seqid: 584, Book: "Colossians", Chapter: "1", Verse: "9" },
  { seqid: 585, Book: "Revelation of John", Chapter: "2", Verse: "20" },
  { seqid: 586, Book: "Matthew", Chapter: "9", Verse: "37" },
  { seqid: 587, Book: "Matthew", Chapter: "9", Verse: "38" },
  { seqid: 588, Book: "Ezekiel", Chapter: "6", Verse: "37" },
  { seqid: 589, Book: "Isaiah", Chapter: "5", Verse: "11" },
  { seqid: 590, Book: "Matthew", Chapter: "7", Verse: "7" },
  { seqid: 591, Book: "John", Chapter: "15", Verse: "7" },
  { seqid: 592, Book: "Ephesians", Chapter: "3", Verse: "20" },
  { seqid: 593, Book: "Ephesians", Chapter: "6", Verse: "17" },
  { seqid: 594, Book: "John", Chapter: "6", Verse: "63" },
  { seqid: 595, Book: "Jeremiah", Chapter: "15", Verse: "16" },
  { seqid: 596, Book: "Psalms", Chapter: "4", Verse: "8" },
  { seqid: 597, Book: "Ezekiel", Chapter: "3", Verse: "1" },
  { seqid: 598, Book: "Psalms", Chapter: "9", Verse: "130" },
  { seqid: 599, Book: "Colossians", Chapter: "3", Verse: "16" },
  { seqid: 600, Book: "II Timothy", Chapter: "3", Verse: "15" },
  { seqid: 601, Book: "Acts", Chapter: "17", Verse: "11" },
  { seqid: 602, Book: "I Peter", Chapter: "2", Verse: "2" },
  { seqid: 603, Book: "II Peter", Chapter: "1", Verse: "20" },
  { seqid: 604, Book: "Isaiah", Chapter: "8", Verse: "13" },
  { seqid: 605, Book: "II Corinthians", Chapter: "3", Verse: "16" },
  { seqid: 606, Book: "John", Chapter: "5", Verse: "39" },
  { seqid: 607, Book: "Ephesians", Chapter: "6", Verse: "17" },
  { seqid: 608, Book: "Psalms", Chapter: "9", Verse: "97" },
  { seqid: 609, Book: "Hebrews", Chapter: "4", Verse: "2" },
  { seqid: 610, Book: "Psalms", Chapter: "9", Verse: "11" },
  { seqid: 611, Book: "Psalms", Chapter: "9", Verse: "162" },
  { seqid: 612, Book: "Luke", Chapter: "4", Verse: "45" },
  { seqid: 613, Book: "Nehemiah", Chapter: "8", Verse: "13" },
  { seqid: 614, Book: "I Corinthians", Chapter: "2", Verse: "13" },
  { seqid: 615, Book: "II Peter", Chapter: "1", Verse: "19" },
  { seqid: 616, Book: "I Timothy", Chapter: "5", Verse: "17" },
  { seqid: 617, Book: "Psalms", Chapter: "9", Verse: "147" },
  { seqid: 618, Book: "Psalms", Chapter: "7", Verse: "8" },
  { seqid: 619, Book: "Lamentations", Chapter: "3", Verse: "22" },
  { seqid: 620, Book: "Lamentations", Chapter: "3", Verse: "23" },
  { seqid: 621, Book: "Psalms", Chapter: "8", Verse: "13" },
  { seqid: 622, Book: "Mark", Chapter: "1", Verse: "35" },
  { seqid: 623, Book: "Exodus", Chapter: "16", Verse: "21" },
  { seqid: 624, Book: "John", Chapter: "6", Verse: "51" },
  { seqid: 625, Book: "Psalms", Chapter: "3", Verse: "1" },
  { seqid: 626, Book: "II Corinthians", Chapter: "4", Verse: "16" },
  { seqid: 627, Book: "Proverbs", Chapter: "4", Verse: "18" },
  { seqid: 628, Book: "Judges", Chapter: "5", Verse: "31" },
  { seqid: 629, Book: "Hebrews", Chapter: "10", Verse: "25" },
  { seqid: 630, Book: "I Corinthians", Chapter: "14", Verse: "26" },
  { seqid: 631, Book: "John", Chapter: "10", Verse: "16" },
  { seqid: 632, Book: "Acts", Chapter: "2", Verse: "42" },
  { seqid: 633, Book: "Acts", Chapter: "20", Verse: "7" },
  { seqid: 634, Book: "Acts", Chapter: "1", Verse: "14" },
  { seqid: 635, Book: "Acts", Chapter: "5", Verse: "42" },
  { seqid: 636, Book: "I Corinthians", Chapter: "14", Verse: "23" },
  { seqid: 637, Book: "Acts", Chapter: "2", Verse: "46" },
  { seqid: 638, Book: "Luke", Chapter: "2", Verse: "19" },
  { seqid: 639, Book: "Luke", Chapter: "2", Verse: "20" },
  { seqid: 640, Book: "I Corinthians", Chapter: "11", Verse: "26" },
  { seqid: 641, Book: "I Corinthians", Chapter: "10", Verse: "16" },
  { seqid: 642, Book: "Matthew", Chapter: "6", Verse: "29" },
  { seqid: 643, Book: "Hebrews", Chapter: "2", Verse: "12" },
  { seqid: 644, Book: "I Corinthians", Chapter: "5", Verse: "8" },
  { seqid: 645, Book: "Ephesians", Chapter: "5", Verse: "18" },
  { seqid: 646, Book: "Ephesians", Chapter: "5", Verse: "19" },
  { seqid: 647, Book: "Hebrews", Chapter: "13", Verse: "15" },
  { seqid: 648, Book: "Acts", Chapter: "16", Verse: "25" },
  { seqid: 649, Book: "Isaiah", Chapter: "12", Verse: "2" },
  { seqid: 650, Book: "Isaiah", Chapter: "5", Verse: "10" },
  { seqid: 651, Book: "Hebrews", Chapter: "2", Verse: "12" },
  { seqid: 652, Book: "Matthew", Chapter: "6", Verse: "30" },
  { seqid: 653, Book: "Psalms", Chapter: "5", Verse: "1" },
  { seqid: 654, Book: "Matthew", Chapter: "1", Verse: "16" },
  { seqid: 655, Book: "Psalms", Chapter: "9", Verse: "164" },
  { seqid: 656, Book: "I Corinthians", Chapter: "14", Verse: "31" },
  { seqid: 657, Book: "Numbers", Chapter: "11", Verse: "29" },
  { seqid: 658, Book: "I Corinthians", Chapter: "14", Verse: "1" },
  { seqid: 659, Book: "I Corinthians", Chapter: "14", Verse: "3" },
  { seqid: 660, Book: "I Thessalonians", Chapter: "5", Verse: "20" },
  { seqid: 661, Book: "I Corinthians", Chapter: "14", Verse: "24" },
  { seqid: 662, Book: "I Corinthians", Chapter: "14", Verse: "25" },
  { seqid: 663, Book: "II Samuel", Chapter: "3", Verse: "2" },
  { seqid: 664, Book: "John", Chapter: "3", Verse: "34" },
  { seqid: 665, Book: "Hebrews", Chapter: "1", Verse: "1" },
  { seqid: 666, Book: "Hebrews", Chapter: "1", Verse: "2" },
  { seqid: 667, Book: "John", Chapter: "14", Verse: "10" },
  { seqid: 668, Book: "Acts", Chapter: "5", Verse: "20" },
  { seqid: 669, Book: "II Corinthians", Chapter: "4", Verse: "13" },
  { seqid: 670, Book: "I Corinthians", Chapter: "14", Verse: "32" },
  { seqid: 671, Book: "Psalms", Chapter: "5", Verse: "1" },
  { seqid: 672, Book: "II Timothy", Chapter: "4", Verse: "2" },
  { seqid: 673, Book: "Ezekiel", Chapter: "7", Verse: "10" },
  { seqid: 674, Book: "Acts", Chapter: "19", Verse: "20" },
  { seqid: 675, Book: "Mark", Chapter: "12", Verse: "30" },
  { seqid: 676, Book: "Mark", Chapter: "12", Verse: "30" },
  { seqid: 677, Book: "Psalms", Chapter: "3", Verse: "25" },
  { seqid: 678, Book: "Revelation of John", Chapter: "2", Verse: "4" },
  { seqid: 679, Book: "Romans", Chapter: "8", Verse: "28" },
  { seqid: 680, Book: "I Corinthians", Chapter: "2", Verse: "9" },
  { seqid: 681, Book: "I John", Chapter: "4", Verse: "19" },
  { seqid: 682, Book: "Galatians", Chapter: "2", Verse: "20" },
  { seqid: 683, Book: "II Corinthians", Chapter: "5", Verse: "14" },
  { seqid: 684, Book: "I Peter", Chapter: "1", Verse: "8" },
  { seqid: 685, Book: "Matthew", Chapter: "6", Verse: "7" },
  { seqid: 686, Book: "I Corinthians", Chapter: "8", Verse: "3" },
  { seqid: 687, Book: "II Corinthians", Chapter: "3", Verse: "16" },
  { seqid: 688, Book: "I John", Chapter: "4", Verse: "21" },
  { seqid: 689, Book: "John", Chapter: "14", Verse: "21" },
  { seqid: 690, Book: "John", Chapter: "1", Verse: "16" },
  { seqid: 691, Book: "II Timothy", Chapter: "4", Verse: "8" },
  { seqid: 692, Book: "Romans", Chapter: "8", Verse: "35" },
  { seqid: 693, Book: "Romans", Chapter: "8", Verse: "37" },
  { seqid: 694, Book: "Romans", Chapter: "12", Verse: "11" },
  { seqid: 695, Book: "I Thessalonians", Chapter: "5", Verse: "19" },
  { seqid: 696, Book: "II Timothy", Chapter: "1", Verse: "6" },
  { seqid: 697, Book: "II Timothy", Chapter: "1", Verse: "7" },
  { seqid: 698, Book: "Romans", Chapter: "1", Verse: "9" },
  { seqid: 699, Book: "Philippians", Chapter: "3", Verse: "3" },
  { seqid: 700, Book: "John", Chapter: "4", Verse: "24" },
  { seqid: 701, Book: "I Corinthians", Chapter: "6", Verse: "17" },
  { seqid: 702, Book: "Galatians", Chapter: "5", Verse: "16" },
  { seqid: 703, Book: "Galatians", Chapter: "5", Verse: "25" },
  { seqid: 704, Book: "Romans", Chapter: "7", Verse: "6" },
  { seqid: 705, Book: "Proverbs", Chapter: "20", Verse: "27" },
  { seqid: 706, Book: "II Timothy", Chapter: "4", Verse: "22" },
  { seqid: 707, Book: "Ezra", Chapter: "1", Verse: "5" },
  { seqid: 708, Book: "Galatians", Chapter: "6", Verse: "8" },
  { seqid: 709, Book: "Galatians", Chapter: "5", Verse: "22" },
  { seqid: 710, Book: "Galatians", Chapter: "5", Verse: "23" },
  { seqid: 711, Book: "Hebrews", Chapter: "8", Verse: "12" },
  { seqid: 712, Book: "Psalms", Chapter: "1", Verse: "2" },
  { seqid: 713, Book: "Proverbs", Chapter: "8", Verse: "13" },
  { seqid: 714, Book: "Luke", Chapter: "7", Verse: "47" },
  { seqid: 715, Book: "Matthew", Chapter: "4", Verse: "14" },
  { seqid: 716, Book: "Matthew", Chapter: "8", Verse: "19" },
  { seqid: 717, Book: "Acts", Chapter: "1", Verse: "8" },
  { seqid: 718, Book: "John", Chapter: "15", Verse: "16" },
  { seqid: 719, Book: "Romans", Chapter: "16", Verse: "25" },
  { seqid: 720, Book: "Romans", Chapter: "1", Verse: "16" },
  { seqid: 721, Book: "I Corinthians", Chapter: "9", Verse: "16" },
  { seqid: 722, Book: "I Corinthians", Chapter: "9", Verse: "22" },
  { seqid: 723, Book: "I Corinthians", Chapter: "1", Verse: "23" },
  { seqid: 724, Book: "Luke", Chapter: "4", Verse: "18" },
  { seqid: 725, Book: "Romans", Chapter: "10", Verse: "14" },
  { seqid: 726, Book: "Romans", Chapter: "10", Verse: "15" },
  { seqid: 727, Book: "Romans", Chapter: "1", Verse: "5" },
  { seqid: 728, Book: "Philippians", Chapter: "1", Verse: "12" },
  { seqid: 729, Book: "Philippians", Chapter: "1", Verse: "5" },
  { seqid: 730, Book: "Philippians", Chapter: "1", Verse: "7" },
  { seqid: 731, Book: "II Timothy", Chapter: "1", Verse: "8" },
  { seqid: 732, Book: "Acts", Chapter: "20", Verse: "24" },
  { seqid: 733, Book: "Romans", Chapter: "10", Verse: "9" },
  { seqid: 734, Book: "Romans", Chapter: "10", Verse: "10" },
  { seqid: 735, Book: "Romans", Chapter: "9", Verse: "23" },
  { seqid: 736, Book: "I Thessalonians", Chapter: "5", Verse: "23" },
  { seqid: 737, Book: "Genesis", Chapter: "2", Verse: "9" },
  { seqid: 738, Book: "Zechariah", Chapter: "12", Verse: "1" },
  { seqid: 739, Book: "Isaiah", Chapter: "6", Verse: "1" },
  { seqid: 740, Book: "Isaiah", Chapter: "6", Verse: "2" },
  { seqid: 741, Book: "Ecclesiastes", Chapter: "3", Verse: "11" },
  { seqid: 742, Book: "Acts", Chapter: "17", Verse: "26" },
  { seqid: 743, Book: "Matthew", Chapter: "16", Verse: "26" },
  { seqid: 744, Book: "Romans", Chapter: "3", Verse: "23" },
  { seqid: 745, Book: "Romans", Chapter: "7", Verse: "20" },
  { seqid: 746, Book: "Romans", Chapter: "6", Verse: "23" },
  { seqid: 747, Book: "Hebrews", Chapter: "9", Verse: "27" },
  { seqid: 748, Book: "Ephesians", Chapter: "2", Verse: "4" },
  { seqid: 749, Book: "Ephesians", Chapter: "2", Verse: "5" },
  { seqid: 750, Book: "Jeremiah", Chapter: "17", Verse: "9" },
  { seqid: 751, Book: "II Corinthians", Chapter: "10", Verse: "5" },
  { seqid: 752, Book: "Psalms", Chapter: "90", Verse: "10" },
  { seqid: 753, Book: "John", Chapter: "1", Verse: "14" },
  { seqid: 754, Book: "Romans", Chapter: "5", Verse: "8" },
  { seqid: 755, Book: "John", Chapter: "1", Verse: "29" },
  { seqid: 756, Book: "John", Chapter: "3", Verse: "14" },
  { seqid: 757, Book: "John", Chapter: "12", Verse: "24" },
  { seqid: 758, Book: "I Corinthians", Chapter: "15", Verse: "45" },
  { seqid: 759, Book: "John", Chapter: "3", Verse: "3" },
  { seqid: 760, Book: "Romans", Chapter: "8", Verse: "29" },
  { seqid: 761, Book: "Romans", Chapter: "8", Verse: "29" },
  { seqid: 762, Book: "Deuteronomy", Chapter: "30", Verse: "19" },
  { seqid: 763, Book: "Acts", Chapter: "3", Verse: "19" },
  { seqid: 764, Book: "Luke", Chapter: "13", Verse: "3" },
  { seqid: 765, Book: "John", Chapter: "1", Verse: "12" },
  { seqid: 766, Book: "Acts", Chapter: "4", Verse: "12" },
  { seqid: 767, Book: "Mark", Chapter: "16", Verse: "16" },
  { seqid: 768, Book: "Romans", Chapter: "12", Verse: "1" },
  { seqid: 769, Book: "I Corinthians", Chapter: "6", Verse: "19" },
  { seqid: 770, Book: "I Corinthians", Chapter: "6", Verse: "20" },
  { seqid: 771, Book: "Exodus", Chapter: "1", Verse: "5" },
  { seqid: 772, Book: "II Corinthians", Chapter: "5", Verse: "15" },
  { seqid: 773, Book: "Philippians", Chapter: "2", Verse: "17" },
  { seqid: 774, Book: "Leviticus", Chapter: "1", Verse: "9" },
  { seqid: 775, Book: "Psalms", Chapter: "1", Verse: "3" },
  { seqid: 776, Book: "Romans", Chapter: "6", Verse: "13" },
  { seqid: 777, Book: "Luke", Chapter: "14", Verse: "26" },
  { seqid: 778, Book: "Mark", Chapter: "14", Verse: "6" },
  { seqid: 779, Book: "Matthew", Chapter: "6", Verse: "24" },
  { seqid: 780, Book: "Luke", Chapter: "6", Verse: "38" },
  { seqid: 781, Book: "Matthew", Chapter: "6", Verse: "3" },
  { seqid: 782, Book: "Matthew", Chapter: "6", Verse: "4" },
  { seqid: 783, Book: "Malachi", Chapter: "3", Verse: "10" },
  { seqid: 784, Book: "Luke", Chapter: "19", Verse: "8" },
  { seqid: 785, Book: "Matthew", Chapter: "6", Verse: "19" },
  { seqid: 786, Book: "Matthew", Chapter: "6", Verse: "20" },
  { seqid: 787, Book: "Luke", Chapter: "12", Verse: "34" },
  { seqid: 788, Book: "Luke", Chapter: "1", Verse: "4" },
  { seqid: 789, Book: "I Timothy", Chapter: "6", Verse: "17" },
  { seqid: 790, Book: "Acts", Chapter: "20", Verse: "35" },
  { seqid: 791, Book: "II Corinthians", Chapter: "9", Verse: "6" },
  { seqid: 792, Book: "II Corinthians", Chapter: "9", Verse: "7" },
  { seqid: 793, Book: "II Corinthians", Chapter: "8", Verse: "15" },
  { seqid: 794, Book: "Genesis", Chapter: "8", Verse: "22" },
  { seqid: 795, Book: "Matthew", Chapter: "2", Verse: "21" },
  { seqid: 796, Book: "Philippians", Chapter: "4", Verse: "18" },
  { seqid: 797, Book: "Philippians", Chapter: "4", Verse: "19" },
  { seqid: 798, Book: "II Corinthians", Chapter: "8", Verse: "9" },
  { seqid: 799, Book: "II Corinthians", Chapter: "8", Verse: "4" },
  { seqid: 800, Book: "I John", Chapter: "3", Verse: "1" },
  { seqid: 801, Book: "Romans", Chapter: "5", Verse: "10" },
  { seqid: 802, Book: "John", Chapter: "6", Verse: "56" },
  { seqid: 803, Book: "John", Chapter: "6", Verse: "57" },
  { seqid: 804, Book: "Romans", Chapter: "8", Verse: "28" },
  { seqid: 805, Book: "Romans", Chapter: "8", Verse: "2" },
  { seqid: 806, Book: "I John", Chapter: "5", Verse: "11" },
  { seqid: 807, Book: "II Peter", Chapter: "1", Verse: "4" },
  { seqid: 808, Book: "Matthew", Chapter: "5", Verse: "48" },
  { seqid: 809, Book: "I Peter", Chapter: "1", Verse: "15" },
  { seqid: 810, Book: "I John", Chapter: "4", Verse: "7" },
  { seqid: 811, Book: "I John", Chapter: "4", Verse: "8" },
  { seqid: 812, Book: "Ephesians", Chapter: "5", Verse: "8" },
  { seqid: 813, Book: "Ephesians", Chapter: "1", Verse: "5" },
  { seqid: 814, Book: "Romans", Chapter: "10", Verse: "12" },
  { seqid: 815, Book: "I Corinthians", Chapter: "2", Verse: "16" },
  { seqid: 816, Book: "Romans", Chapter: "8", Verse: "29" },
  { seqid: 817, Book: "Philippians", Chapter: "3", Verse: "21" },
  { seqid: 818, Book: "Isaiah", Chapter: "3", Verse: "10" },
  { seqid: 819, Book: "Isaiah", Chapter: "4", Verse: "6" },
  { seqid: 820, Book: "II Samuel", Chapter: "7", Verse: "12" },
  { seqid: 821, Book: "II Samuel", Chapter: "7", Verse: "13" },
  { seqid: 822, Book: "II Samuel", Chapter: "7", Verse: "14" },
  { seqid: 823, Book: "John", Chapter: "20", Verse: "17" },
  { seqid: 824, Book: "Hebrews", Chapter: "2", Verse: "11" },
  { seqid: 825, Book: "Ephesians", Chapter: "2", Verse: "19" },
  { seqid: 826, Book: "John", Chapter: "12", Verse: "24" },
  { seqid: 827, Book: "Romans", Chapter: "11", Verse: "17" },
  { seqid: 828, Book: "John", Chapter: "15", Verse: "5" },
  { seqid: 829, Book: "I Peter", Chapter: "1", Verse: "23" },
  { seqid: 830, Book: "I John", Chapter: "3", Verse: "9" },
  { seqid: 831, Book: "John", Chapter: "3", Verse: "29" },
  { seqid: 832, Book: "John", Chapter: "3", Verse: "30" },
  { seqid: 833, Book: "Revelation of John", Chapter: "1", Verse: "20" },
  { seqid: 834, Book: "Revelation of John", Chapter: "3", Verse: "12" },
  { seqid: 835, Book: "Revelation of John", Chapter: "1", Verse: "11" },
  { seqid: 836, Book: "Revelation of John", Chapter: "4", Verse: "3" },
  { seqid: 837, Book: "Philippians", Chapter: "1", Verse: "21" },
  { seqid: 838, Book: "Galatians", Chapter: "2", Verse: "20" },
  { seqid: 839, Book: "I Corinthians", Chapter: "7", Verse: "25" },
  { seqid: 840, Book: "I Corinthians", Chapter: "7", Verse: "40" },
  { seqid: 841, Book: "Philippians", Chapter: "3", Verse: "10" },
  { seqid: 842, Book: "Matthew", Chapter: "1", Verse: "23" },
  { seqid: 843, Book: "Romans", Chapter: "1", Verse: "3" },
  { seqid: 844, Book: "Romans", Chapter: "1", Verse: "4" },
  { seqid: 845, Book: "Hebrews", Chapter: "9", Verse: "15" },
  { seqid: 846, Book: "Hebrews", Chapter: "7", Verse: "25" },
  { seqid: 847, Book: "Isaiah", Chapter: "9", Verse: "6" },
  { seqid: 848, Book: "Genesis", Chapter: "3", Verse: "15" },
  { seqid: 849, Book: "Isaiah", Chapter: "7", Verse: "14" },
  { seqid: 850, Book: "Luke", Chapter: "1", Verse: "35" },
  { seqid: 851, Book: "John", Chapter: "8", Verse: "12" },
  { seqid: 852, Book: "Matthew", Chapter: "19", Verse: "14" },
  { seqid: 853, Book: "Isaiah", Chapter: "2", Verse: "3" },
  { seqid: 854, Book: "Hebrews", Chapter: "9", Verse: "12" },
  { seqid: 855, Book: "Hebrews", Chapter: "9", Verse: "28" },
  { seqid: 856, Book: "Hebrews", Chapter: "9", Verse: "216" },
  { seqid: 857, Book: "Romans", Chapter: "6", Verse: "6" },
  { seqid: 858, Book: "Hebrews", Chapter: "2", Verse: "9" },
  { seqid: 859, Book: "Colossians", Chapter: "1", Verse: "20" },
  { seqid: 860, Book: "Ephesians", Chapter: "2", Verse: "15" },
  { seqid: 861, Book: "Hebrews", Chapter: "2", Verse: "14" },
  { seqid: 862, Book: "Colossians", Chapter: "2", Verse: "15" },
  { seqid: 863, Book: "I Peter", Chapter: "3", Verse: "18" },
  { seqid: 864, Book: "John", Chapter: "12", Verse: "24" },
  { seqid: 865, Book: "II Corinthians", Chapter: "5", Verse: "16" },
  { seqid: 866, Book: "Revelation of John", Chapter: "4", Verse: "5" },
  { seqid: 867, Book: "Revelation of John", Chapter: "5", Verse: "6" },
  { seqid: 868, Book: "Revelation of John", Chapter: "2", Verse: "7" },
  { seqid: 869, Book: "Revelation of John", Chapter: "12", Verse: "11" },
  { seqid: 870, Book: "Hebrews", Chapter: "12", Verse: "22" },
  { seqid: 871, Book: "Revelation of John", Chapter: "14", Verse: "1" },
  { seqid: 872, Book: "Revelation of John", Chapter: "1", Verse: "2" },
  { seqid: 873, Book: "John", Chapter: "14", Verse: "1" },
  { seqid: 874, Book: "John", Chapter: "14", Verse: "10" },
  { seqid: 875, Book: "John", Chapter: "7", Verse: "39" },
  { seqid: 876, Book: "John", Chapter: "14", Verse: "16" },
  { seqid: 877, Book: "John", Chapter: "16", Verse: "13" },
  { seqid: 878, Book: "John", Chapter: "14", Verse: "20" },
  { seqid: 879, Book: "John", Chapter: "3", Verse: "5" },
  { seqid: 880, Book: "John", Chapter: "14", Verse: "16" },
  { seqid: 881, Book: "John", Chapter: "14", Verse: "17" },
  { seqid: 882, Book: "John", Chapter: "17", Verse: "21" },
  { seqid: 883, Book: "John", Chapter: "17", Verse: "23" },
  { seqid: 884, Book: "John", Chapter: "16", Verse: "33" },
  { seqid: 885, Book: "John", Chapter: "15", Verse: "4" },
  { seqid: 886, Book: "John", Chapter: "15", Verse: "5" },
  { seqid: 887, Book: "Hebrews", Chapter: "9", Verse: "22" },
  { seqid: 888, Book: "Romans", Chapter: "3", Verse: "24" },
  { seqid: 889, Book: "I John", Chapter: "4", Verse: "10" },
  { seqid: 890, Book: "Romans", Chapter: "5", Verse: "2" },
  { seqid: 891, Book: "Romans", Chapter: "5", Verse: "10" },
  { seqid: 892, Book: "Hebrews", Chapter: "13", Verse: "12" },
  { seqid: 893, Book: "I John", Chapter: "1", Verse: "7" },
  { seqid: 894, Book: "Romans", Chapter: "5", Verse: "18" },
  { seqid: 895, Book: "I Peter", Chapter: "1", Verse: "3" },
  { seqid: 896, Book: "John", Chapter: "3", Verse: "5" },
  { seqid: 897, Book: "Titus", Chapter: "3", Verse: "5" },
  { seqid: 898, Book: "Romans", Chapter: "6", Verse: "19" },
  { seqid: 899, Book: "Romans", Chapter: "6", Verse: "22" },
  { seqid: 900, Book: "I Thessalonians", Chapter: "5", Verse: "23" },
  { seqid: 901, Book: "Ephesians", Chapter: "4", Verse: "23" },
  { seqid: 902, Book: "II Corinthians", Chapter: "4", Verse: "16" },
  { seqid: 903, Book: "II Corinthians", Chapter: "5", Verse: "17" },
  { seqid: 904, Book: "Ephesians", Chapter: "4", Verse: "24" },
  { seqid: 905, Book: "Romans", Chapter: "12", Verse: "2" },
  { seqid: 906, Book: "II Corinthians", Chapter: "3", Verse: "18" },
  { seqid: 907, Book: "Romans", Chapter: "8", Verse: "29" },
  { seqid: 908, Book: "I John", Chapter: "3", Verse: "2" },
  { seqid: 909, Book: "Philippians", Chapter: "3", Verse: "21" },
  { seqid: 910, Book: "Colossians", Chapter: "1", Verse: "27" },
  { seqid: 911, Book: "Romans", Chapter: "8", Verse: "30" },
  { seqid: 912, Book: "Ephesians", Chapter: "4", Verse: "30" },
  { seqid: 913, Book: "Romans", Chapter: "8", Verse: "23" },
  { seqid: 914, Book: "II Corinthians", Chapter: "5", Verse: "4" },
  { seqid: 915, Book: "Hebrews", Chapter: "2", Verse: "10" },
  { seqid: 916, Book: "Romans", Chapter: "5", Verse: "17" },
  { seqid: 917, Book: "Romans", Chapter: "5", Verse: "21" },
  { seqid: 918, Book: "Romans", Chapter: "8", Verse: "35" },
  { seqid: 919, Book: "Romans", Chapter: "8", Verse: "37" },
  { seqid: 920, Book: "John", Chapter: "12", Verse: "23" },
  { seqid: 921, Book: "Luke", Chapter: "4", Verse: "26" },
  { seqid: 922, Book: "John", Chapter: "14", Verse: "19" },
  { seqid: 923, Book: "John", Chapter: "14", Verse: "17" },
  { seqid: 924, Book: "John", Chapter: "14", Verse: "2" },
  { seqid: 925, Book: "John", Chapter: "14", Verse: "23" },
  { seqid: 926, Book: "John", Chapter: "15", Verse: "5" },
  { seqid: 927, Book: "John", Chapter: "16", Verse: "21" },
  { seqid: 928, Book: "John", Chapter: "6", Verse: "29" },
  { seqid: 929, Book: "I Corinthians", Chapter: "12", Verse: "3" },
  { seqid: 930, Book: "I John", Chapter: "4", Verse: "16" },
  { seqid: 931, Book: "Hebrews", Chapter: "9", Verse: "4" },
  { seqid: 932, Book: "Revelation of John", Chapter: "2", Verse: "17" },
  { seqid: 933, Book: "Revelation of John", Chapter: "1", Verse: "3" },
  { seqid: 934, Book: "Revelation of John", Chapter: "1", Verse: "22" },
  { seqid: 935, Book: "Psalms", Chapter: "7", Verse: "4" },
  { seqid: 936, Book: "Psalms", Chapter: "3", Verse: "6" },
  { seqid: 937, Book: "I Timothy", Chapter: "1", Verse: "3" },
  { seqid: 938, Book: "I Timothy", Chapter: "1", Verse: "4" },
  { seqid: 939, Book: "Hebrews", Chapter: "1", Verse: "1" },
  { seqid: 940, Book: "Colossians", Chapter: "1", Verse: "26" },
  { seqid: 941, Book: "Hebrews", Chapter: "2", Verse: "1" },
  { seqid: 942, Book: "Hebrews", Chapter: "2", Verse: "3" },
  { seqid: 943, Book: "Ephesians", Chapter: "2", Verse: "20" },
  { seqid: 944, Book: "I Corinthians", Chapter: "4", Verse: "17" },
  { seqid: 945, Book: "Titus", Chapter: "1", Verse: "9" },
  { seqid: 946, Book: "II Timothy", Chapter: "3", Verse: "10" },
  { seqid: 947, Book: "I Corinthians", Chapter: "11", Verse: "1" },
  { seqid: 948, Book: "II Timothy", Chapter: "4", Verse: "7" },
  { seqid: 949, Book: "Jude", Chapter: "0", Verse: "3" },
  { seqid: 950, Book: "I Timothy", Chapter: "6", Verse: "12" },
  { seqid: 951, Book: "II Corinthians", Chapter: "4", Verse: "1" },
  { seqid: 952, Book: "Acts", Chapter: "20", Verse: "24" },
  { seqid: 953, Book: "Ephesians", Chapter: "4", Verse: "12" },
  { seqid: 954, Book: "II Corinthians", Chapter: "3", Verse: "7" },
  { seqid: 955, Book: "II Corinthians", Chapter: "3", Verse: "8" },
  { seqid: 956, Book: "II Corinthians", Chapter: "3", Verse: "9" },
  { seqid: 957, Book: "II Corinthians", Chapter: "5", Verse: "18" },
  { seqid: 958, Book: "II Corinthians", Chapter: "5", Verse: "19" },
  { seqid: 959, Book: "II Corinthians", Chapter: "5", Verse: "20" },
  { seqid: 960, Book: "Hebrews", Chapter: "8", Verse: "10" },
  { seqid: 961, Book: "Hebrews", Chapter: "8", Verse: "11" },
  { seqid: 962, Book: "II Corinthians", Chapter: "1", Verse: "9" },
  { seqid: 963, Book: "II Corinthians", Chapter: "4", Verse: "11" },
  { seqid: 964, Book: "II Corinthians", Chapter: "1", Verse: "3" },
  { seqid: 965, Book: "II Corinthians", Chapter: "1", Verse: "4" },
  { seqid: 966, Book: "II Corinthians", Chapter: "2", Verse: "14" },
  { seqid: 967, Book: "II Corinthians", Chapter: "2", Verse: "15" },
  { seqid: 968, Book: "II Corinthians", Chapter: "2", Verse: "16" },
  { seqid: 969, Book: "II Corinthians", Chapter: "3", Verse: "3" },
  { seqid: 970, Book: "II Corinthians", Chapter: "3", Verse: "18" },
  { seqid: 971, Book: "II Corinthians", Chapter: "4", Verse: "7" },
  { seqid: 972, Book: "I Timothy", Chapter: "4", Verse: "6" },
  { seqid: 973, Book: "Song of Solomon", Chapter: "1", Verse: "2" },
  { seqid: 974, Book: "Song of Solomon", Chapter: "1", Verse: "4" },
  { seqid: 975, Book: "II Corinthians", Chapter: "11", Verse: "2" },
  { seqid: 976, Book: "Ephesians", Chapter: "5", Verse: "25" },
  { seqid: 977, Book: "Ephesians", Chapter: "5", Verse: "26" },
  { seqid: 978, Book: "Ephesians", Chapter: "5", Verse: "27" },
  { seqid: 979, Book: "Hosea", Chapter: "2", Verse: "19" },
  { seqid: 980, Book: "Isaiah", Chapter: "4", Verse: "5" },
  { seqid: 981, Book: "Revelation of John", Chapter: "19", Verse: "7" },
  { seqid: 982, Book: "Revelation of John", Chapter: "1", Verse: "2" },
  { seqid: 983, Book: "I John", Chapter: "3", Verse: "1" },
  { seqid: 984, Book: "Romans", Chapter: "5", Verse: "10" },
  { seqid: 985, Book: "John", Chapter: "6", Verse: "56" },
  { seqid: 986, Book: "John", Chapter: "6", Verse: "57" },
  { seqid: 987, Book: "Romans", Chapter: "8", Verse: "28" },
  { seqid: 988, Book: "Romans", Chapter: "8", Verse: "2" },
  { seqid: 989, Book: "I John", Chapter: "5", Verse: "11" },
  { seqid: 990, Book: "II Peter", Chapter: "1", Verse: "4" },
  { seqid: 991, Book: "Matthew", Chapter: "5", Verse: "48" },
  { seqid: 992, Book: "I Peter", Chapter: "1", Verse: "15" },
  { seqid: 993, Book: "I John", Chapter: "4", Verse: "7" },
  { seqid: 994, Book: "I John", Chapter: "4", Verse: "8" },
  { seqid: 995, Book: "Ephesians", Chapter: "5", Verse: "8" },
  { seqid: 996, Book: "Ephesians", Chapter: "1", Verse: "5" },
  { seqid: 997, Book: "Romans", Chapter: "10", Verse: "12" },
  { seqid: 998, Book: "I Corinthians", Chapter: "2", Verse: "16" },
  { seqid: 999, Book: "Romans", Chapter: "8", Verse: "29" },
  { seqid: 1000, Book: "Philippians", Chapter: "3", Verse: "21" },
  { seqid: 1001, Book: "Isaiah", Chapter: "3", Verse: "10" },
  { seqid: 1002, Book: "Isaiah", Chapter: "4", Verse: "6" },
  { seqid: 1003, Book: "II Samuel", Chapter: "7", Verse: "12" },
  { seqid: 1004, Book: "II Samuel", Chapter: "7", Verse: "13" },
  { seqid: 1005, Book: "II Samuel", Chapter: "7", Verse: "14" },
  { seqid: 1006, Book: "John", Chapter: "20", Verse: "17" },
  { seqid: 1007, Book: "Hebrews", Chapter: "2", Verse: "11" },
  { seqid: 1008, Book: "Ephesians", Chapter: "2", Verse: "19" },
  { seqid: 1009, Book: "John", Chapter: "12", Verse: "24" },
  { seqid: 1010, Book: "Romans", Chapter: "11", Verse: "17" },
  { seqid: 1011, Book: "John", Chapter: "15", Verse: "5" },
  { seqid: 1012, Book: "I Peter", Chapter: "1", Verse: "23" },
  { seqid: 1013, Book: "I John", Chapter: "3", Verse: "9" },
  { seqid: 1014, Book: "John", Chapter: "3", Verse: "29" },
  { seqid: 1015, Book: "John", Chapter: "3", Verse: "30" },
  { seqid: 1016, Book: "Revelation of John", Chapter: "1", Verse: "20" },
  { seqid: 1017, Book: "Revelation of John", Chapter: "3", Verse: "12" },
  { seqid: 1018, Book: "Revelation of John", Chapter: "1", Verse: "11" },
  { seqid: 1019, Book: "Revelation of John", Chapter: "4", Verse: "3" },
  { seqid: 1020, Book: "Philippians", Chapter: "1", Verse: "21" },
  { seqid: 1021, Book: "Galatians", Chapter: "2", Verse: "20" },
  { seqid: 1022, Book: "I Corinthians", Chapter: "7", Verse: "25" },
  { seqid: 1023, Book: "I Corinthians", Chapter: "7", Verse: "40" },
  { seqid: 1024, Book: "Philippians", Chapter: "3", Verse: "10" },
  { seqid: 1025, Book: "Matthew", Chapter: "1", Verse: "23" },
  { seqid: 1026, Book: "Romans", Chapter: "1", Verse: "3" },
  { seqid: 1027, Book: "Romans", Chapter: "1", Verse: "4" },
  { seqid: 1028, Book: "Hebrews", Chapter: "9", Verse: "15" },
  { seqid: 1029, Book: "Hebrews", Chapter: "7", Verse: "25" },
  { seqid: 1030, Book: "Isaiah", Chapter: "9", Verse: "6" },
  { seqid: 1031, Book: "Genesis", Chapter: "3", Verse: "15" },
  { seqid: 1032, Book: "Isaiah", Chapter: "7", Verse: "14" },
  { seqid: 1033, Book: "Luke", Chapter: "1", Verse: "35" },
  { seqid: 1034, Book: "John", Chapter: "8", Verse: "12" },
  { seqid: 1035, Book: "Matthew", Chapter: "19", Verse: "14" },
  { seqid: 1036, Book: "Isaiah", Chapter: "2", Verse: "3" },
  { seqid: 1037, Book: "Hebrews", Chapter: "9", Verse: "12" },
  { seqid: 1038, Book: "Hebrews", Chapter: "9", Verse: "28" },
  { seqid: 1039, Book: "Hebrews", Chapter: "9", Verse: "216" },
  { seqid: 1040, Book: "Romans", Chapter: "6", Verse: "6" },
  { seqid: 1041, Book: "Hebrews", Chapter: "2", Verse: "9" },
  { seqid: 1042, Book: "Colossians", Chapter: "1", Verse: "20" },
  { seqid: 1043, Book: "Ephesians", Chapter: "2", Verse: "15" },
  { seqid: 1044, Book: "Hebrews", Chapter: "2", Verse: "14" },
  { seqid: 1045, Book: "Colossians", Chapter: "2", Verse: "15" },
  { seqid: 1046, Book: "I Peter", Chapter: "3", Verse: "18" },
  { seqid: 1047, Book: "John", Chapter: "12", Verse: "24" },
  { seqid: 1048, Book: "II Corinthians", Chapter: "5", Verse: "16" },
  { seqid: 1049, Book: "Revelation of John", Chapter: "4", Verse: "5" },
  { seqid: 1050, Book: "Revelation of John", Chapter: "5", Verse: "6" },
  { seqid: 1051, Book: "Revelation of John", Chapter: "2", Verse: "7" },
  { seqid: 1052, Book: "Revelation of John", Chapter: "12", Verse: "11" },
  { seqid: 1053, Book: "Hebrews", Chapter: "12", Verse: "22" },
  { seqid: 1054, Book: "Revelation of John", Chapter: "14", Verse: "1" },
  { seqid: 1055, Book: "Revelation of John", Chapter: "1", Verse: "2" },
  { seqid: 1056, Book: "John", Chapter: "14", Verse: "1" },
  { seqid: 1057, Book: "John", Chapter: "14", Verse: "10" },
  { seqid: 1058, Book: "John", Chapter: "7", Verse: "39" },
  { seqid: 1059, Book: "John", Chapter: "14", Verse: "16" },
  { seqid: 1060, Book: "John", Chapter: "16", Verse: "13" },
  { seqid: 1061, Book: "John", Chapter: "14", Verse: "20" },
  { seqid: 1062, Book: "John", Chapter: "3", Verse: "5" },
  { seqid: 1063, Book: "John", Chapter: "14", Verse: "16" },
  { seqid: 1064, Book: "John", Chapter: "14", Verse: "17" },
  { seqid: 1065, Book: "John", Chapter: "17", Verse: "21" },
  { seqid: 1066, Book: "John", Chapter: "17", Verse: "23" },
  { seqid: 1067, Book: "John", Chapter: "16", Verse: "33" },
  { seqid: 1068, Book: "John", Chapter: "15", Verse: "4" },
  { seqid: 1069, Book: "John", Chapter: "15", Verse: "5" },
  { seqid: 1070, Book: "Hebrews", Chapter: "9", Verse: "22" },
  { seqid: 1071, Book: "Romans", Chapter: "3", Verse: "24" },
  { seqid: 1072, Book: "I John", Chapter: "4", Verse: "10" },
  { seqid: 1073, Book: "Romans", Chapter: "5", Verse: "2" },
  { seqid: 1074, Book: "Romans", Chapter: "5", Verse: "10" },
  { seqid: 1075, Book: "Hebrews", Chapter: "13", Verse: "12" },
  { seqid: 1076, Book: "I John", Chapter: "1", Verse: "7" },
  { seqid: 1077, Book: "Romans", Chapter: "5", Verse: "18" },
  { seqid: 1078, Book: "I Peter", Chapter: "1", Verse: "3" },
  { seqid: 1079, Book: "John", Chapter: "3", Verse: "5" },
  { seqid: 1080, Book: "Titus", Chapter: "3", Verse: "5" },
  { seqid: 1081, Book: "Romans", Chapter: "6", Verse: "19" },
  { seqid: 1082, Book: "Romans", Chapter: "6", Verse: "22" },
  { seqid: 1083, Book: "I Thessalonians", Chapter: "5", Verse: "23" },
  { seqid: 1084, Book: "Ephesians", Chapter: "4", Verse: "23" },
  { seqid: 1085, Book: "II Corinthians", Chapter: "4", Verse: "16" },
  { seqid: 1086, Book: "II Corinthians", Chapter: "5", Verse: "17" },
  { seqid: 1087, Book: "Ephesians", Chapter: "4", Verse: "24" },
  { seqid: 1088, Book: "Romans", Chapter: "12", Verse: "2" },
  { seqid: 1089, Book: "II Corinthians", Chapter: "3", Verse: "18" },
  { seqid: 1090, Book: "Romans", Chapter: "8", Verse: "29" },
  { seqid: 1091, Book: "I John", Chapter: "3", Verse: "2" },
  { seqid: 1092, Book: "Philippians", Chapter: "3", Verse: "21" },
  { seqid: 1093, Book: "Colossians", Chapter: "1", Verse: "27" },
  { seqid: 1094, Book: "Romans", Chapter: "8", Verse: "30" },
  { seqid: 1095, Book: "Ephesians", Chapter: "4", Verse: "30" },
  { seqid: 1096, Book: "Romans", Chapter: "8", Verse: "23" },
  { seqid: 1097, Book: "II Corinthians", Chapter: "5", Verse: "4" },
  { seqid: 1098, Book: "Hebrews", Chapter: "2", Verse: "10" },
  { seqid: 1099, Book: "Romans", Chapter: "5", Verse: "17" },
  { seqid: 1100, Book: "Romans", Chapter: "5", Verse: "21" },
  { seqid: 1101, Book: "Romans", Chapter: "8", Verse: "35" },
  { seqid: 1102, Book: "Romans", Chapter: "8", Verse: "37" },
  { seqid: 1103, Book: "John", Chapter: "12", Verse: "23" },
  { seqid: 1104, Book: "Luke", Chapter: "4", Verse: "26" },
  { seqid: 1105, Book: "John", Chapter: "14", Verse: "19" },
  { seqid: 1106, Book: "John", Chapter: "14", Verse: "17" },
  { seqid: 1107, Book: "John", Chapter: "14", Verse: "2" },
  { seqid: 1108, Book: "John", Chapter: "14", Verse: "23" },
  { seqid: 1109, Book: "John", Chapter: "15", Verse: "5" },
  { seqid: 1110, Book: "John", Chapter: "16", Verse: "21" },
  { seqid: 1111, Book: "John", Chapter: "6", Verse: "29" },
  { seqid: 1112, Book: "I Corinthians", Chapter: "12", Verse: "3" },
  { seqid: 1113, Book: "I John", Chapter: "4", Verse: "16" },
  { seqid: 1114, Book: "Hebrews", Chapter: "9", Verse: "4" },
  { seqid: 1115, Book: "Revelation of John", Chapter: "2", Verse: "17" },
  { seqid: 1116, Book: "Revelation of John", Chapter: "1", Verse: "3" },
  { seqid: 1117, Book: "Revelation of John", Chapter: "1", Verse: "22" },
  { seqid: 1118, Book: "Psalms", Chapter: "7", Verse: "4" },
  { seqid: 1119, Book: "Psalms", Chapter: "3", Verse: "6" },
  { seqid: 1120, Book: "I Timothy", Chapter: "1", Verse: "3" },
  { seqid: 1121, Book: "I Timothy", Chapter: "1", Verse: "4" },
  { seqid: 1122, Book: "Hebrews", Chapter: "1", Verse: "1" },
  { seqid: 1123, Book: "Colossians", Chapter: "1", Verse: "26" },
  { seqid: 1124, Book: "Hebrews", Chapter: "2", Verse: "1" },
  { seqid: 1125, Book: "Hebrews", Chapter: "2", Verse: "3" },
  { seqid: 1126, Book: "Ephesians", Chapter: "2", Verse: "20" },
  { seqid: 1127, Book: "I Corinthians", Chapter: "4", Verse: "17" },
  { seqid: 1128, Book: "Titus", Chapter: "1", Verse: "9" },
  { seqid: 1129, Book: "II Timothy", Chapter: "3", Verse: "10" },
  { seqid: 1130, Book: "I Corinthians", Chapter: "11", Verse: "1" },
  { seqid: 1131, Book: "II Timothy", Chapter: "4", Verse: "7" },
  { seqid: 1132, Book: "Jude", Chapter: "0", Verse: "3" },
  { seqid: 1133, Book: "I Timothy", Chapter: "6", Verse: "12" },
  { seqid: 1134, Book: "II Corinthians", Chapter: "4", Verse: "1" },
  { seqid: 1135, Book: "Acts", Chapter: "20", Verse: "24" },
  { seqid: 1136, Book: "Ephesians", Chapter: "4", Verse: "12" },
  { seqid: 1137, Book: "II Corinthians", Chapter: "3", Verse: "7" },
  { seqid: 1138, Book: "II Corinthians", Chapter: "3", Verse: "8" },
  { seqid: 1139, Book: "II Corinthians", Chapter: "3", Verse: "9" },
  { seqid: 1140, Book: "II Corinthians", Chapter: "5", Verse: "18" },
  { seqid: 1141, Book: "II Corinthians", Chapter: "5", Verse: "19" },
  { seqid: 1142, Book: "II Corinthians", Chapter: "5", Verse: "20" },
  { seqid: 1143, Book: "Hebrews", Chapter: "8", Verse: "10" },
  { seqid: 1144, Book: "Hebrews", Chapter: "8", Verse: "11" },
  { seqid: 1145, Book: "II Corinthians", Chapter: "1", Verse: "9" },
  { seqid: 1146, Book: "II Corinthians", Chapter: "4", Verse: "11" },
  { seqid: 1147, Book: "II Corinthians", Chapter: "1", Verse: "3" },
  { seqid: 1148, Book: "II Corinthians", Chapter: "1", Verse: "4" },
  { seqid: 1149, Book: "II Corinthians", Chapter: "2", Verse: "14" },
  { seqid: 1150, Book: "II Corinthians", Chapter: "2", Verse: "15" },
  { seqid: 1151, Book: "II Corinthians", Chapter: "2", Verse: "16" },
  { seqid: 1152, Book: "II Corinthians", Chapter: "3", Verse: "3" },
  { seqid: 1153, Book: "II Corinthians", Chapter: "3", Verse: "18" },
  { seqid: 1154, Book: "II Corinthians", Chapter: "4", Verse: "7" },
];

export const CLASSIC_VERSES_COUNT = CLASSIC_VERSES.length;
